import * as Sentry from '@sentry/react'
import { getIntercomHashFromUser } from '../Utils/GenerateUserIntercomHash'
import { getUserData } from '../Utils/ServerUtil'

// Initialize Intercom for user
export const initializeIntercom = (userData) => {
    const hash = getIntercomHashFromUser(userData.email)

    window.Intercom('update', {
        hide_default_launcher: false,
        name: userData.name, // Full name
        email: userData.email, // Email address
        user_hash: hash,
        created_at: Date.now(),
    })

    window.Intercom('boot', {
        app_id: 'fl2igt9h',
    })
}

// Initialize PostHog for user
export const initializePostHog = (userData) => {
    const currentOrganization = JSON.parse(
        localStorage.getItem('selectedOrg')
    )

    // Identify posthog user
    window.posthog.identify(userData?.email)
    window.posthog.people.set({
        email: userData?.email,
        'Organization Name': currentOrganization?.name,
        'Organization Key': currentOrganization?.organization_id,
    })
}

// Initialize Sentry for user
export const initializeSentry = (authData, userData) => {
    Sentry.configureScope(function (scope) {
        scope.setUser({
            id: authData.signInUserSession.idToken.payload.sub,
            email: userData.email,
        })
    })
}

// Initialize all user services
export const initializeUserServices = (authData) => {
    const userData = getUserData()
    
    initializeIntercom(userData)
    initializePostHog(userData)
    initializeSentry(authData, userData)
}